module.exports = __webpack_public_path__ + "img/ico_iot_sensor.ebb1e86d.svg";